// extracted by mini-css-extract-plugin
export default {"loading":"table_loading__TQHRh","strip":"table_strip__SzfQE","hover":"table_hover__ceGvp","border":"table_border__2kXJG"};